module.exports = __webpack_public_path__ + "img/慢充面.a4aada45.png";